import axios from '../axios-auth'
import orginal_axios from "axios";

export const saleReportService = {
    getSaleReportList,
    getSaleSummaryList,
    getAllSaleReportList,
    getWaySaleReportList,
    getWaySaleSummaryList,
    getAllWaySaleReportList,
    getAllCustomerSaleReport,
    getCustomerSaleReport,
    getDailySaleReport,
    getAllDailySaleReportList,
    getSaleReportByProductCode,
    getPrintAllSaleReportByProductCode,
    getSaleAnalysisReport,
    getSaleAnalysisReportPrint,
    getSaleReportExcelExport,
    getSaleReportByCategory,
    getAllSaleReportByCategory,
    getSaleAnalysisReportExcel
}

function getSaleReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.saleNo) {
        params["saleNo"] = searchParams.saleNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/sale-report", { params });
}

function getWaySaleReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.saleNo) {
        params["saleNo="] = searchParams.saleNo;
    }
    if (searchParams.wayAssignNo) {
        params["wayAssignNo"] = searchParams.wayAssignNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.customerShopId) {
        params["customerShopId"] = searchParams.customerShopId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/way-sale-report", { params });
}

function getAllSaleReportList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.saleNo) {
        params["saleNo"] = searchParams.saleNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/sale-report", { params });
}

function getSaleSummaryList(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.saleNo) {
        params["saleNo="] = searchParams.saleNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/sale-summary-report", { params });
}

function getWaySaleSummaryList(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.saleNo) {
        params["saleNo"] = searchParams.saleNo;
    }
    if (searchParams.wayAssignNo) {
        params["wayAssignNo"] = searchParams.wayAssignNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.customerShopId) {
        params["customerShopId"] = searchParams.customerShopId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/way-sale-summary-report", { params });
}

function getAllWaySaleReportList(searchParams) {
    let params = {};

    if (searchParams.counterId) {
        params["counterId"] = searchParams.counterId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.saleNo) {
        params["saleNo"] = searchParams.saleNo;
    }
    if (searchParams.wayAssignNo) {
        params["wayAssignNo"] = searchParams.wayAssignNo;
    }
    if (searchParams.userName) {
        params["userName"] = searchParams.userName;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.fromTime) {
        params["fromTime"] = searchParams.fromTime;
    }
    if (searchParams.toTime) {
        params["toTime"] = searchParams.toTime;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.cashierId) {
        params["cashierId"] = searchParams.cashierId;
    }
    if (searchParams.customerShopId) {
        params["customerShopId"] = searchParams.customerShopId;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    return axios.get("/auth/way-sale-report", { params });
}

function getCustomerSaleReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }

    return axios.get("/auth/customer-sale-report", { params });
}

function getAllCustomerSaleReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }

    return axios.get("/auth/customer-sale-report-print", { params });
}
function getDailySaleReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    return axios.get("/auth/daily-sale-report", { params });
}

function getAllDailySaleReportList(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/daily-sale-report", { params });
}

function getSaleReportByProductCode(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }

    return axios.get("/auth/sale-report-by-product-code", { params });
}
function getPrintAllSaleReportByProductCode(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/print-all-sale-report-by-code", { params });
}

function getSaleAnalysisReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }

    return axios.get("/auth/sale-analysis-report", { params });
}

function getSaleAnalysisReportPrint(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }

    return axios.get("/auth/sale-analysis-report", { params });
}

function getSaleAnalysisReportExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/sale-analysis-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getSaleReportExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/daily-sale-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}


function getSaleReportByCategory(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/sale-report-by-category", { params });
}

function getAllSaleReportByCategory(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/sale-report-by-category", { params });
}